export const CONTRACT_NUM = '5 Million'
export const TENDER_NUM = '2 Million'
export const AWARDS_NUM = '2 Million'

export const REVIEWS_URL = 'https://www.reviews.co.uk/company-reviews/store/www.contractfinderpro.com'

export const DEMO_BOOKING_URL = 'https://link.totalsaleshq.com/widget/booking/nqDvluEGCng5KAEtPCqv'
export const DEMO_BOOKING_SCRIPT = 'https://link.totalsaleshq.com/js/form_embed.js'

export function loadDemoBookingScript() {
    if (document.querySelector(`script[src="${DEMO_BOOKING_SCRIPT}"]`)) return
    const script = document.createElement('script')
    script.src = DEMO_BOOKING_SCRIPT
    script.type = 'text/javascript'
    document.body.appendChild(script)
}

// Clean neo routes - never emit legacy .aspx paths from our own links. Legacy inbound
// .aspx still works via the web.config redirects; we just don't send anyone there.
export const quicksetup = '/quick-setup'
export const loginpage = '/login'
export const registerpage = '/register'

export function buildCoreUrl(path: string): string {
    const normalizedPath = path.replace(/^\/+/, '')
    const { hostname, origin } = window.location
    const normalizedHost = hostname.toLowerCase()

    if (normalizedHost === 'localhost' || normalizedHost === '127.0.0.1' || normalizedHost === '::1' || normalizedHost === '[::1]') {
        // dev: the core app (neo) runs on its own port, not PublicWeb's origin
        return `http://localhost:7777/${normalizedPath}`
    }

    if (normalizedHost === 'www.contractfinderpro.com') {
        return `https://core.contractfinderpro.com/${normalizedPath}`
    }

    const envHostMatch = normalizedHost.match(/^(?:www\.)?(.+)\.contractfinderpro\.com$/)
    if (envHostMatch) {
        return `https://core.${envHostMatch[1]}.contractfinderpro.com/${normalizedPath}`
    }

    return `https://core.contractfinderpro.com/${normalizedPath}`
}

export function buildCoreApiUrl(path: string): string {
    const normalizedPath = path.replace(/^\/+/, '')
    const hostname = window.location.hostname.toLowerCase()
    if (hostname.includes('localhost')) return `http://localhost:9999/${normalizedPath}`

    const envHostMatch = hostname.match(/^(?:www\.)?(beta[a-z0-9-]*)\.contractfinderpro\.com$/)
    if (envHostMatch) return `https://api-${envHostMatch[1]}.contractfinderpro.com/${normalizedPath}`

    return `https://api.contractfinderpro.com/${normalizedPath}`
}

export const ALL_NUTS = [
    'east-midlands-england', 'east-of-england', 'greater-london-england',
    'ireland', 'north-east-england', 'north-west-england', 'northern-ireland',
    'scotland', 'south-east-england', 'south-west-england',
    'wales', 'west-midlands-england', 'yorkshire-and-the-humber-england',
]

export function buildApiUrl(q = '', page = 1, ob = 'pd_desc', mi = '0', ma = 'max', nuts = ALL_NUTS, ti = 1): string {
    const today = new Date()
    const fmt = (d: Date) => d.toISOString().slice(0, 10).replace(/-/g, '')
    const oneYearAgo = new Date(today)
    oneYearAgo.setFullYear(today.getFullYear() - 1)
    const nutsStr = nuts.map(n => `&nuts=${n}`).join('')
    const hostname = window.location.hostname.toLowerCase()

    var apipath = hostname.includes('localhost') ? `http://localhost:9999/` : `https://api.contractfinderpro.com`;

    return (
        `${apipath}/api/search2` +
        `?ed=${fmt(today)}&f=pu&f=lo&f=su&f=cp&f=ti&f=aw&gb=` +
        `&ma=${ma}&mi=${mi}` +
        nutsStr +
        `&ob=${ob}&p=${page}&ps=50&q=${encodeURIComponent(q)}&r=${Date.now()}&rc=false&sd=${fmt(oneYearAgo)}&ti=${ti}`
    )
}


export function pwdCheck(pwd: string) {
    return {
        length: pwd.length >= 8,
        number: /[0-9]/.test(pwd),
        lower: /[a-z]/.test(pwd),
        upper: /[A-Z]/.test(pwd),
    }
}

export async function getIp(): Promise<string> {
    try {
        const r = await fetch('https://api.ipify.org?format=json')
        return (await r.json()).ip
    } catch { return 'null' }
}

export function readCookie(name: string) {
    return document.cookie.match(new RegExp(`(?:^|;)\\s*${name}=([^;]*)`))?.[1] ?? ''
}

